import React from 'react';
import BaseForm from '../../../../../../components/form/BaseForm/BaseForm';
import { useUserInfoTrasferSectionViewModel } from './UserInfoTrasferSectionViewModel';
import Button from '../../../../../../components/Button';
import { ACCOUNT_USER_DETAIL_STATUS } from '../../../../../../constants/service/app/accountUserConstants';
import UserInfoTransferModal from './UserInfoTransferModal';
import UserInfoTransferConfirmModal from './UserInfoTransferConfirmModal';
import { AccountUserDetailTypeV2 } from '../../common/types/accountUserDetail';

export interface IUserInfoTransferSectionProps {
  userDetailInfo: AccountUserDetailTypeV2;
}

const UserInfoTransferSection = (props: IUserInfoTransferSectionProps): JSX.Element => {
  const {
    isActiveTransfer,
    isActiveTransferResult,
    ineditableUserInfo,
    userStatus,
    transferInfo,
    transferUserInfoResult,
    handleTransferUser,
    handleActiveTransfer,
    handleCloseTransferInfoModal,
    handleOpenTransferResultModal,
    handleCloseTransferResultModal,
  } = useUserInfoTrasferSectionViewModel(props);
  const { loginType, account, createDate, updateDate } = ineditableUserInfo;

  return (
    <div className="account-user-detail-section">
      <div className="title-header-section">
        <div className="title">유저 로그인 정보</div>
        {(userStatus === ACCOUNT_USER_DETAIL_STATUS.INACTIVE ||
          userStatus === ACCOUNT_USER_DETAIL_STATUS.DELETE_FROM_USER) && (
          <div className="buttons">
            <Button color="primary" text="계정 변경하기" onClick={handleActiveTransfer} />
          </div>
        )}
      </div>
      <div className="account-user-detail-section-content">
        <div className="form-wrap">
          <BaseForm className="account-user-detail-base-form" label="로그인 타입" content={loginType} />
          <BaseForm className="account-user-detail-base-form" label="유저 계정" content={account} />
        </div>
        <div className="form-wrap">
          <BaseForm className="account-user-detail-base-form" label="가입일자" content={createDate} />
          <BaseForm className="account-user-detail-base-form" label="수정일자" content={updateDate} />
        </div>
      </div>
      {!!transferInfo && isActiveTransfer && (
        <UserInfoTransferModal
          transferInfo={transferInfo}
          onTransfer={handleOpenTransferResultModal}
          onClose={handleCloseTransferInfoModal}
        />
      )}
      {isActiveTransferResult && (
        <UserInfoTransferConfirmModal
          onOk={handleTransferUser}
          onClose={handleCloseTransferResultModal}
          info={transferUserInfoResult}
        />
      )}
    </div>
  );
};

export default UserInfoTransferSection;
